// extracted by mini-css-extract-plugin
export default {"wrapper":"Popper_wrapper__+IYFL"};